import { Button, Stack } from "react-bootstrap";
import CustomModal from "../../components/modal";
import { FailureDetailsDisplayModel } from "./failure-display";

interface FailureDetailsModalProps {
    details: FailureDetailsDisplayModel | null;
    onClose: () => void;
}

export default function FailureDetailsModal({ details, onClose }: FailureDetailsModalProps) {
    return (
        <CustomModal
            isShow={details !== null}
            handleClose={onClose}
            header={<p className="heading">Failure details</p>}
            size="md"
        >
            <Stack gap={2}>
                <div><strong>Category</strong><br />{details?.categoryLabel}</div>
                <div><strong>Message</strong><br />{details?.message}</div>
                <div><strong>Failed at</strong><br />{details?.failedAt}</div>
                <div><strong>Attempt</strong><br />{details?.attempt}</div>
                <div><strong>Correlation reference</strong><br />{details?.correlationReference}</div>
                <Button variant="popup-btn btn btn-primary crbc-bg-color w-100 mt-3" type="button" onClick={onClose}>
                    Close
                </Button>
            </Stack>
        </CustomModal>
    );
}